import { Injectable } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { UrlValidator } from "@atenea-cms";
import { EsportsTeam } from "./esports-team.model";

@Injectable()
export class EsportsTeamFormService {
  constructor(private fb: FormBuilder) {}

  getForm(esportsTeam: EsportsTeam = new EsportsTeam()): FormGroup {
    return this.fb.group({
      _id: [esportsTeam._id],
      name: [esportsTeam.name, Validators.required],
      image: [esportsTeam.image],
      background: [esportsTeam.background],
      title: [esportsTeam.title],
      description: [esportsTeam.description],
      url: [esportsTeam.url, UrlValidator],
      position: [esportsTeam.position],
      active: [esportsTeam.active],
    });
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-teams/shared/esports-team-form.service.ts